module.exports = __webpack_public_path__ + "assets/aeafe77b75fb9bdca009f156f37dab21.jpg";